import { useEffect, useState } from "react";
import api from "@/lib/api";
import { History } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "");

export function TechHistory({ fid, refreshKey }) {
  const [list, setList] = useState(null);
  useEffect(() => { api.get(`/technique/files/${fid}/history`).then((r) => setList(r.data)); }, [fid, refreshKey]);
  if (!list) return <p className="text-sm text-slate-400">Chargement…</p>;
  return (
    <div className="rounded-lg border bg-white overflow-hidden" data-testid="tech-history">
      {list.length === 0 ? <p className="px-4 py-3 text-sm text-slate-400">Aucune action enregistrée.</p> : (
        <ol className="divide-y">{list.map((h) => (
          <li key={h.id} className="flex gap-3 px-4 py-2.5 text-sm" data-testid={`hist-${h.id}`}>
            <History className="h-4 w-4 text-brand-600 mt-0.5 shrink-0" />
            <div className="flex-1"><p><b>{h.action}</b>{h.detail ? <span className="text-slate-600"> — {h.detail}</span> : ""}</p><p className="text-xs text-slate-400">{fmt(h.at)} · {h.by}</p></div>
          </li>))}</ol>
      )}
    </div>
  );
}

export function TechTeams({ assignments }) {
  const groups = assignments.reduce((acc, a) => { const k = a.equipe || "Sans équipe"; (acc[k] = acc[k] || []).push(a); return acc; }, {});
  const keys = Object.keys(groups).sort((a, b) => (a === "Sans équipe") - (b === "Sans équipe") || a.localeCompare(b));
  if (!keys.length) return <p className="text-sm text-slate-400 rounded-lg border border-dashed p-6 text-center">Aucune équipe. Renseignez le champ « Équipe » lors de l'affectation des artisans et ouvriers.</p>;
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="tech-teams">
      {keys.map((k) => (
        <div key={k} className="rounded-lg border bg-white" data-testid={`team-${k}`}>
          <div className="px-4 py-2.5 border-b bg-slate-50 flex items-center"><span className="font-semibold text-sm">{k}</span><span className="ml-auto text-xs text-slate-400">{new Set(groups[k].map((a) => a.ref_id)).size} membre(s)</span></div>
          <ul className="divide-y text-sm">{groups[k].map((a) => (
            <li key={a.id} className="px-4 py-2"><span className="font-medium">{a.ref_name}</span> <span className="text-xs text-slate-400">{a.kind === "artisan" ? "Artisan" : "Ouvrier"}{a.specialite ? ` · ${a.specialite}` : ""}</span><p className="text-xs text-slate-500">{a.task_titre || "Chantier (général)"}</p></li>))}</ul>
        </div>
      ))}
    </div>
  );
}
